import ButtonOnly from "../button/buttonOnly";
import InputText from "../inputText/inputText";
import SelectBox from "../selectBox/selectBox";
import "./footer.css";

function FooterButton({
  handleName,
  setHandleName,
  handleName2,
  setHandleName2,
  handleName3,
  setHandleName3,
  handleName3_options,
  ftIdName,
  buttonClass,
  btnClass,
  buttonValue = "미션 시작하기",
  onFinish,
  disabled,
}) {
  buttonClass = buttonClass ?? btnClass ?? "inputBtn03 mt16";

  return (
    <div id={ftIdName}>
      <InputText
        textClass="input02"
        textValue="팀명을 입력하세요."
        handleName={handleName}
        setHandleName={setHandleName}
      />
      <SelectBox
        selectClass="select02 mt16"
        textValue="역할을 선택하세요."
        options={handleName3_options}
        selectedValue={handleName3}
        setSelectedValue={setHandleName3}
      />
      <InputText
        textClass="input02 mt16"
        textValue="입장 코드를 입력하세요."
        handleName={handleName2}
        setHandleName={setHandleName2}
      />
      <ButtonOnly
        btnValue={buttonValue}
        btnClass={buttonClass}
        onFinish={onFinish}
        disabled={disabled}
      />
    </div>
  );
}

export default FooterButton;
